<script>
  const STATE_KEY = 'WeiyiStat_pb_driver'
  export default {
    name: 'Driver',
    props: {
      videoBg: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        driverShow: false,
        videoTipShow: false,
        recordTipShow: false
      }
    },
    created() {
      const stateKey = localStorage.getItem(STATE_KEY)
      if (stateKey != 1) {
        this.driverInit()
      }
    },
    methods: {
      driverInit() {
        const { videoBg } = this
        this.driverShow = true
        this.videoTipShow = videoBg ? true : false
        this.recordTipShow = videoBg ? false : true
        localStorage.setItem(STATE_KEY, 1)
      },
      handleNext() {
        this.videoTipShow = false
        this.recordTipShow = true
      },
      handleClose() {
        if (this.videoTipShow || !this.recordTipShow) return
        this.driverShow = false
      }
    }
  }
</script>
<template>
  <div
    v-if="driverShow"
    class="driver-bg"
    @click="handleClose"
  >
    <div v-if="videoTipShow && videoBg" class="driver-banner">
      <div class="video-show">
        <p class="video-bg" :style="{'backgroundImage': `url(${ videoBg }`}" />
        <i class="banner-play-icon" />
      </div>
      <div class="video-op">
        <img
          class="tips"
          src="//media.winbaoxian.com/autoUpload/planbook/piece22x_f8089ee44582b39.png"
          alt=""
          @click.stop="handleNext"
        >
      </div>
    </div>
    <div class="driver-record">
      <img
        v-if="recordTipShow"
        class="tips"
        src="//media.winbaoxian.com/autoUpload/planbook/123_c49cc84f310607b.png"
        alt=""
      >
    </div>
  </div>
</template>
<style scoped>
  @import 'variable';

  .driver-bg {
    background: rgba(0, 0, 0, .5);
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    zoom: 1;
    z-index: 500;
    text-align: center;
    .driver-banner {
      width: 94.667%;
      display: inline-block;
      .video-show {
        position: relative;
        height: 147px;
      }
      .video-bg {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        top: 0;
        left: 0;
        border-radius: 6px;
        background-size: cover;
        background-repeat: no-repeat;
      }
      .banner-play-icon {
        width: 45px;
        height: 45px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: 2px;
        -webkit-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
        color: #fff;
        display: inline-block;
        background-image: url(https://media.winbaoxian.com/autoUpload/common/icon3x_79c728e47e633ce.png);
        background-size: 100%;
        background-repeat: no-repeat;
        z-index: 3;
      }
      .video-op {
        text-align: right;
        .tips {
          width: 127px;
        }
        .btn {
          padding: 7px 18px;
          border: 1px solid #fff;
          border-radius: 15px;
          text-shadow: none;
          color: #fff;
          background: none;
        }
      }
    }
    .driver-record {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding-left: 15px;
      text-align: left;
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
      .tips {
        width: 161px;
      }
    }
  }
</style>